export const PENDING = 'pending';
export const NEW = 'new';
export const APPROVED = 'approved';
export const ESTABLISHED = 'established';